module.exports = __webpack_public_path__ + "static/img/xxzj.3f29c64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/xxzj.jpg
// module id = PN1i
// module chunks = 0